import React from "react";
import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { Statistic, type StatisticProps, TextColumn, type TextColumnProps } from "ui/text";
import { Rule } from "ui/rule";

function TextColumnWithStatistic({
  title,
  description,
  statistic,
}: Pick<TextColumnProps, "title" | "description"> & { statistic: Pick<StatisticProps, "title" | "description"> }) {
  return (
    <Box w={{ base: "mediaMaxW.mobile", md: "auto" }} maxW="100%" mx="auto">
      <TextColumn title={title} description={description} />
      <Rule />
      <Statistic
        size="sm"
        title={
          <Text as="span" color="brand.textSecondary.light">
            {statistic.title}
          </Text>
        }
        description={statistic.description}
      />
    </Box>
  );
}

export function FeatureStatistics() {
  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap="biggest" mt="biggest">
      <TextColumnWithStatistic
        title="On-demand scalability"
        description="Deploy bursty workloads at a moment’s notice. No hidden concurrency limits, ever."
        statistic={{ title: "1 Million+", description: "daily sync jobs" }}
      />

      <TextColumnWithStatistic
        title="Unlimited volume"
        description="Sync your largest models without breaking a sweat (or breaking the bank)."
        statistic={{ title: "2 Trillion+", description: "rows synced annually" }}
      />

      <TextColumnWithStatistic
        title="High availability"
        description="Keep your production data pipelines flowing 24/7/365."
        statistic={{ title: "99.99%", description: "global uptime" }}
      />
    </SimpleGrid>
  );
}
